import { defineElement, TemplateElement, html } from '@webtides/element-js';
import { Chart, registerables } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';

Chart.register(...registerables);
import style from './chart-element.css';

class ChartElement extends TemplateElement {
    myChart = null;
    clicked = 0;

    constructor() {
        super({ styles: [style], autoUpdate: false });
    }

    properties() {
        return {
            chartData: {},
            config: 'doughnut',
            labelTool: 'label',
            color: [],
            empty: '',
            legend: '',
            desktop: false,
            unit: '',
            grid: false,
            currentLocale: 'en',
        };
    }

    connected() {
        let options = {
            rootMargin: '0px',
            threshold: 0.7,
        };

        this._observer = new IntersectionObserver((entries, observer) => {
            this.interSectionCallback(entries, observer);
        }, options);
        this._observer.observe(this);
    }

    interSectionCallback(entries, observer) {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                this.check();
                this._observer.unobserve(this);
            }
        });
        if (this.myChart != null && this.myChart.canvas.clientWidth <= 500) {
            this.myChart.setActiveElements([{ datasetIndex: 0, index: 0 }]);
            this.myChart.tooltip.setActiveElements([{ datasetIndex: 0, index: 0 }]);
        }
    }

    template() {
        return html`
            <div class="h-full w-full">
                <canvas id="myChart" ref="myChart"></canvas>
            </div>
        `;
    }

    check() {
        if (this.config === 'doughnut' || this.config === 'pie') {
            this.renderDorP();
        } else {
            this.renderBorL();
        }
    }

    renderBorL() {
        var indexAxis = 'x';
        if (this.config === 'barLtoR') {
            this.config = 'bar';
            indexAxis = 'y';
        }
        var labelST = this.chartData.map(function (e) {
            return e.item;
        });
        var data = this.chartData.map(function (e) {
            return e.quantity;
        });
        if (this.myChart != null) {
            this.myChart.destroy();
        }
        const ctx = this.$refs.myChart.getContext('2d');
        this.myChart = new Chart(ctx, {
            plugins: [ChartDataLabels],
            type: this.config,
            data: {
                labels: labelST,
                datasets: [
                    {
                        data: data,
                        backgroundColor: this.color,
                        borderColor: this.color,
                        tension: 0.05,
                        fill: false,
                        label: this.legend,
                        borderWidth: 3,
                    },
                ],
            },

            options: {
                onClick(event, elements, chart) {
                    if (elements[0] != null) {
                        if (elements[0].index === thisChart.clicked) {
                            chart.canvas.click();
                            thisChart.clicked = null;
                        } else {
                            thisChart.clicked = elements[0].index;
                        }
                    } else {
                        thisChart.clicked = null;
                    }
                },
                indexAxis: indexAxis,
                scales: {
                    x: {
                        grid: {
                            display: (context) => {
                                if (this.grid) {
                                    return true;
                                } else {
                                    return false;
                                }
                            },
                        },
                    },

                    y: {
                        grid: {
                            display: (context) => {
                                if (this.grid) {
                                    return true;
                                } else {
                                    return false;
                                }
                            },
                        },
                    },
                },
                responsive: true,
                maintainAspectRatio: false,
                elements: {
                    point: {
                        radius: 4,
                    },
                },
                plugins: {
                    datalabels: {
                        display: false,
                    },
                    legend: {
                        display: (context) => {
                            if (this.legend === '') {
                                return false;
                            } else {
                                return true;
                            }
                        },
                    },
                    tooltip: {
                        callbacks: {
                            label: (context) => {
                                if (this.labelTool === 'NULL') {
                                    var dataLabel = context.parsed.y;
                                    if (!isNaN(dataLabel)) {
                                        dataLabel = parseFloat(dataLabel).toLocaleString(this.currentLocale);
                                    }
                                    return dataLabel + this.unit;
                                } else {
                                    return this.labelTool;
                                }
                            },
                        },
                    },
                },
            },
        });
    }

    renderDorP() {
        const thisChart = this;
        var colors = [];
        var labelST = this.chartData.map(function (e) {
            return e.item;
        });
        var data = this.chartData.map(function (e) {
            return e.quantity;
        });
        if (this.empty !== 0) {
            data.push(this.empty);
            labelST.push('empty');
            if (this.color.length === 5) {
                if (data.length < 5) {
                    for (var i = 0; i < data.length - 1; i++) {
                        colors.push(this.color[i]);
                    }
                    colors.push('rgba(0,0,0,0)');
                } else {
                    colors = this.color;
                    for (var i = 0; this.color.length < data.length - 1; i++) {
                        colors.push(this.color[i]);
                    }
                    colors.push('rgba(0,0,0,0)');
                }
            } else {
                colors = this.color;
                for (var i = 2; i < data.length; i++) {
                    colors.push(this.color[0]);
                }
                colors.push('rgba(0,0,0,0)');
            }
        } else {
            colors = this.color;
        }
        if (this.myChart != null) {
            this.myChart.destroy();
        }
        const ctx = this.$refs.myChart.getContext('2d');
        this.myChart = new Chart(ctx, {
            plugins: [ChartDataLabels],
            type: this.config,
            data: {
                labels: labelST,
                datasets: [
                    {
                        data: data,
                        backgroundColor: colors,
                        borderWidth: 4,
                        hoverOffset: 0,
                        hoverBorderColor: colors,
                        hoverBorderWidth: 2,
                        hoverBackgroundColor: colors,
                    },
                ],
            },
            options: {
                onClick(event, elements, chart) {
                    if (elements[0] != null) {
                        if (elements[0].index === thisChart.clicked) {
                            chart.canvas.click();
                            thisChart.clicked = null;
                        } else {
                            thisChart.clicked = elements[0].index;
                        }
                    } else {
                        thisChart.clicked = null;
                    }
                },
                responsive: true,
                maintainAspectRatio: false,
                cutout: (context) => {
                    if (this.config === 'doughnut') {
                        return '80%';
                    } else {
                        return 0;
                    }
                },
                layout: function (context) {
                    var width = context.chart.width;
                    var size = Math.round(width / 4.0);
                    if (width <= 500) {
                        return {
                            padding: 20,
                        };
                    } else {
                        return {
                            padding: 50,
                        };
                    }
                },

                plugins: {
                    datalabels: {
                        display: 'true',
                        backgroundColor: (context) => {
                            var width = context.chart.width;
                            var size = Math.round(width);
                            if (size <= 500 || this.desktop) {
                                return context.dataset.backgroundColor;
                            } else {
                                return null;
                            }
                        },
                        borderColor: 'white',
                        borderRadius: (context) => {
                            var width = context.chart.width;
                            var size = Math.round(width);
                            if (size <= 500 || this.desktop) {
                                return 25;
                            } else {
                                return null;
                            }
                        },
                        borderWidth: (context) => {
                            var width = context.chart.width;
                            var size = Math.round(width);
                            if (size <= 500 || this.desktop) {
                                return 2;
                            } else {
                                return null;
                            }
                        },
                        color: (context) => {
                            var width = context.chart.width;
                            var size = Math.round(width);
                            if (size <= 500 || this.desktop) {
                                return 'white';
                            } else {
                                return 'black';
                            }
                        },
                        padding: (context) => {
                            var width = context.chart.width;
                            var size = Math.round(width);
                            if (size <= 500 || this.desktop) {
                                return 3;
                            } else {
                                return null;
                            }
                        },
                        align: 'end',
                        anchor: (context) => {
                            var width = context.chart.width;
                            var size = Math.round(width);
                            if (size <= 500 || this.desktop) {
                                return 'center';
                            } else {
                                return 'end';
                            }
                        },
                        offset: (context) => {
                            var width = context.chart.width;
                            var size = Math.round(width);
                            if (size <= 500 || this.desktop) {
                                return null;
                            } else {
                                return 5;
                            }
                        },
                        labels: {
                            name: {
                                formatter: (value, context) => {
                                    var width = context.chart.width;
                                    var size = Math.round(width);
                                    if (context.chart.data.labels[context.dataIndex] === 'empty') {
                                        return null;
                                    } else {
                                        if (size <= 500 || this.desktop) {
                                            if (context.dataIndex + 1 >= 10) {
                                                return context.dataIndex + 1;
                                            } else {
                                                return ' ' + (context.dataIndex + 1) + ' ';
                                            }
                                        } else {
                                            return (
                                                context.chart.data.labels[context.dataIndex] + '\n' + value + this.unit
                                            );
                                        }
                                    }
                                },
                                font: (context) => {
                                    var width = context.chart.width;
                                    var size = Math.round(width);
                                    if (size <= 500) {
                                        return {
                                            size: 16,
                                        };
                                    } else {
                                        return {
                                            size: 20,
                                        };
                                    }
                                },
                            },
                        },
                    },
                    legend: {
                        align: function (context) {
                            var width = context.chart.width;
                            var size = Math.round(width);
                            if (size <= 500) {
                                return 'start';
                            } else {
                                return 'center';
                            }
                        },
                        display: (context) => {
                            var width = context.chart.width;
                            var size = Math.round(width);
                            if (size <= 500 || this.desktop) {
                                return true;
                            } else {
                                return false;
                            }
                        },
                        position: (context) => {
                            if (this.desktop && context.chart.width > 500) {
                                return 'right';
                            } else {
                                return 'bottom';
                            }
                        },
                        labels: {
                            padding: 20,
                            boxWidth: 0,
                            generateLabels: (chart) => {
                                const data = chart.data;
                                if (data.labels.length && data.datasets.length) {
                                    const {
                                        labels: { pointStyle },
                                    } = chart.legend.options;

                                    return data.labels.map((label, i) => {
                                        const meta = chart.getDatasetMeta(0);
                                        const style = meta.controller.getStyle(i);

                                        if (label !== 'empty') {
                                            var dataLabel = chart.data.datasets[0].data[i];
                                            if (!isNaN(dataLabel)) {
                                                dataLabel = parseFloat(dataLabel).toLocaleString(this.currentLocale);
                                            }
                                            return {
                                                text: i + 1 + '. ' + label + ' ' + dataLabel + this.unit,
                                                fillStyle: style.backgroundColor,
                                                strokeStyle: style.borderColor,
                                                lineWidth: style.borderWidth,
                                                pointStyle: pointStyle,
                                                hidden: !chart.getDataVisibility(i),

                                                index: i,
                                            };
                                        } else {
                                            return {
                                                text: '',
                                                fillStyle: style.backgroundColor,
                                                strokeStyle: style.borderColor,
                                                lineWidth: style.borderWidth,
                                                pointStyle: pointStyle,
                                                hidden: !chart.getDataVisibility(i),

                                                index: i,
                                            };
                                        }
                                    });
                                }
                                return [];
                            },
                            filter: function (legendItem, data) {
                                if (legendItem.text === 'empty') {
                                    return false;
                                } else {
                                    return true;
                                }
                            },
                            font: {
                                size: function (context) {
                                    var width = context.chart.width;
                                    var size = Math.round(width);
                                    if (size <= 500) {
                                        return 12;
                                    } else {
                                        return 16;
                                    }
                                },
                            },
                        },
                    },
                    tooltip: {
                        filter: function (context) {
                            if (context.chart.data.labels[context.dataIndex] === 'empty') {
                                return false;
                            } else {
                                return true;
                            }
                        },
                        callbacks: {
                            label: (tooltipItem) => {
                                if (this.labelTool === 'NULL') {
                                    var dataLabel = tooltipItem.dataset.data[tooltipItem.dataIndex];
                                    if (!isNaN(dataLabel)) {
                                        dataLabel = parseFloat(dataLabel).toLocaleString(this.currentLocale);
                                    }
                                    return '  ' + tooltipItem.label + ' ' + dataLabel + this.unit;
                                } else {
                                    return '  ' + this.labelTool;
                                }
                            },
                        },
                    },
                },
            },
        });
    }
}

export function define() {
    defineElement('chart-element', ChartElement);
}
